/**
 * @deprecated Cette configuration est remplacée par src/services/config.ts
 * Utilisez import { config } from '../services/config' à la place
 */

import { config } from './config';

// Export de la configuration pour maintenir la compatibilité
export const env = {
    "app_host": config.app.environment,
    "api_host": config.api.baseUrl,
    "signin_with_apple": config.auth.signInWithApple,
    "signin_with_google": config.auth.signInWithGoogle,
    "signin_with_microsoft": config.auth.signInWithMicrosoft,
};
